/**
 * @memberOf loavies.services
 * @constructor
 */
export class CurrencyService {

  /**
   * @param {string} locale
   */
  constructor(locale) {
    this.locale = locale
    this.defaultCurrencyDisplay = 'code'
  }

  /**
   * @param {number|string} price
   * @param {string} [currency]
   * @param {string} [locale]
   * @return {string} price in locale string
   */
  formatToLocalePrice(price, currency = 'EUR', locale = this.locale) {
    return this.getLocalePrice(price, currency, locale)
  }

  /**
   * @param {number|string} price in cents
   * @param {string} [currency]
   * @param {string} [locale]
   * @return {string} price in locale string
   */
  formatCentsToLocalePrice(price, currency = 'EUR', locale = this.locale) {
    const centsToFullPrice = +price / 100

    return this.getLocalePrice(centsToFullPrice, currency, locale)
  }

  /**
   * @param {number|string} price
   * @param {string} currency
   * @param {string} locale
   * @return {string} price in locale string
   */
  getLocalePrice(price, currency, locale) {
    let localePriceFormat
    const currencyDisplay = this.getCurrencyDisplay(locale)

    try {
      localePriceFormat = new Intl.NumberFormat(locale, { style: 'currency', currency, currencyDisplay }).format(price)
    } catch (error) {
      console.warn(error)
    }

    return localePriceFormat
  }

  /**
   * @param {number|string} price
   * @return {number} price in cents
   */
  getPriceInCents(price) {
    const parsedAmount = typeof price === 'string'
      ? parseFloat(price.replace(/,/g, '.'))
      : price

    return Number((parsedAmount * 100).toFixed(0))
  }

  /**
   * @param {string} [locale]
   * @return {string} currency display strings: https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/NumberFormat#parameters
   */
  getCurrencyDisplay(locale = this.locale) {
    return locale === 'fr' ? 'symbol' : this.defaultCurrencyDisplay
  }


  /**
   * @example number: 10, percentage: 10 returns 9
   * @param {number} number
   * @param {number} percentage
   * @return {number}
   */
  subtractPercentageFromNumber(number, percentage) {
    return number - (number * (percentage / 100)).toFixed(2)
  }

  /**
   * @example: number: 10, percentage: 10 returns 1
   * @param {number} number
   * @param {number} percentage
   * @return {number}
   */
  getPercentageOfNumber(number, percentage) {
    return number / 100 * percentage
  }
}
